import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { EffectsModule } from '@ngrx/effects';
import { environment } from '../environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OrderEffects } from './core/effects/order.effects';
import { reducers, metaReducers } from './app.reducers';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from './app-routing.module';
import { UIEffects } from './core/effects/ui.effects';
import { LoaderInterceptorService } from './core/spinner-overlay/loader-interceptor.service';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { CommonModule } from '@angular/common';
import { LoginDialogComponent } from './dialogs/login-dialog/login-dialog.component';
import { ResetPasswordComponent } from './dialogs/reset-password/reset-password.component';
import { SignsRequestDialogComponent } from './dialogs/signs-request-dialog/signs-request-dialog.component';
import { GoogleAddressSearchComponent } from 'src/app/components/google-address-search/google-address-search.component';
import { AuthenticationInterceptor } from './core/interceptors/authentication.interceptor';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { IconsModule } from './client-space/icons/icons.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faBriefcase,
  faCalendarAlt,
  faCheck,
  faCheckCircle,
  faCircle,
  faClock,
  faCog,
  faComments,
  faCreditCard,
  faDownload,
  faExclamation,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileImage,
  faFileInvoice,
  faFileUpload,
  faHourglass,
  faInfoCircle,
  faPen,
  faPlus,
  faPowerOff,
  faQuestionCircle,
  faReceipt,
  faSearch,
  faShareAlt,
  faTags,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faUndo,
  faUpload,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { faHome, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faShippingFast, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { MatFormFieldModule } from '@angular/material/form-field';

registerLocaleData(localeFr);

if (environment.production) {
}

@NgModule({
  declarations: [
    AppComponent,
    LoginDialogComponent,
    ResetPasswordComponent,
    SignsRequestDialogComponent,
    GoogleAddressSearchComponent
  ],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    IconsModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    EffectsModule.forRoot([OrderEffects, UIEffects]),
    HttpClientModule,
    FormsModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    StoreDevtoolsModule.instrument({}),
    AppRoutingModule,
    NgxMaskModule.forRoot(),
    Ng2TelInputModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    { provide: ErrorHandler, useClass: ErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    // Add only the specific icon to the library
    library.addIcons(
      faQuestionCircle,
      faClipboardCheck,
      faHome,
      faCalculator,
      faShippingFast,
      faPhone,
      faAngleDown,
      faUser,
      faBriefcase,
      faReceipt,
      faCog,
      faTags,
      faPowerOff,
      faCheck,
      faThumbsUp,
      faCheckCircle,
      faInfoCircle,
      faArrowLeft,
      faArrowRight,
      faAngleRight,
      faCalendarAlt,
      faTimes,
      faUpload,
      faExclamation,
      faCircle,
      faSearch,
      faUndo,
      faComments,
      faExclamationTriangle,
      faCreditCard,
      faDownload,
      faThumbsDown,
      faEye,
      faPen,
      faShareAlt,
      faInfoCircle,
      faExternalLinkAlt,
      faHourglass,
      faClock,
      faTrash,
      faFileImage,
      faPlus,
      faFileInvoice,
      faFileUpload,
      faFileInvoice
    );
  }
}
